export const blogIndexPath = "/blog";
export const blogIndexTitle = "Doorway blog";
export const blogIndexDescription = "Practical notes on building, sharing, and turning useful internal apps into something a team can rely on.";
